export default {
    login: "/auth/login",
    profile: "/users/me",
    accountList: "/accounts/list",
    accountDetail: "/accounts", // /accounts/{userId}
    updateAccountDetail: "/accounts/update",
    createAccountDetail: "/accounts/create",
    permissionList: "/accounts/permissions/list",
    updateFilterPreference: "/accounts/update/filter-preference",

    emailVerify: "/accounts/email-verify",  // /email-verify/{emailVerifyCode}
    emailVerifyConfirm: "/accounts/email-verify/confirm",
    forgotPassword: "/accounts/forgot-password", // /forgot-password/{email}
    verifyResetPasswordCode: "/accounts/reset-password",    // /reset-password/{resetPasswordCode}
    resetPasswordConfirm: "/accounts/reset-password/confirm",

    // CRM-Contact
    crmGetContact: "/crm/contact",
    crmGetContactDetails: "/crm/contact", // /contacts/{{contactId}}
    crmAddContact: "/crm/contacts",
    crmUpdateContact: "/crm/contact", // /contacts/{{contactId}}
    crmDeleteContact: "/crm/contact", // /contacts/{{contactId}}

    //CRM-Pipeline
    crmGetPipeline: "/crm/pipeline",
    crmAddPipeline: "/crm/pipeline",
    crmDeletePipeline: "/crm/pipeline", //pipielines/{{pipelineId}}
    crmUpdatePipeline: "/crm/pipeline", //pipelines/{{pipelineId}}
    crmGetDealsOfPipeline: "/crm/pipeline", //pipelines/{{pipelineId}}/deals
    crmGetOrganizationOfPipeline: "/crm/pipeline",

    //CRM-Deals
    crmGetDeals: "/crm/deal",
    crmSearchDeals: "/crm/deal", //deals/search?term=<string>
    crmGetDealsDetails: "/crm/deal", //deals/{{dealId}}
    crmListProductOfDeals: "/crm/deal", //deals/{{dealId}}/products
    crmAddDeals: "/crm/deal",
    crmAddProductToDeals: "/crm/deal", //deals/{{dealId}}/products
    crmUpdateDeal: "/crm/deal", //deals/{{dealId}}
    crmUpdateProductDetailsOfDeal: "/crm/deal", //deals/{{dealId}}/products/{{productId}}
    crmDeleteDeals: "/crm/deal", //deals/{{dealId}}
    crmDeleteAttachedProduct: "/crm/deal", //deals/{{dealId}}/products/{{productId}}
    crmGetDealHistory: "/crm/deal", //deals/{{dealId}}/history
    crmPostDealHistory: "/crm/deal", //deals/{{dealId}}/history
    crmDeleteDeal: "/crm/deal", //deals/{{dealId}}

    //CRM-Products
    crmGetProducts: "/crm/product",
    crmAddProduct: "/crm/product",
    crmDeleteProduct: "/crm/product", //products/{{productId}}
    crmSyncProducts: "/crm/product/sync",
    crmMergeProducts: "/crm/product/merge",
    crmUpdateProduct: "/crm/product", //products/{{productId}}

    //CRM-Users
    crmGetUsers: "/crm/user",
    crmGetOneUser: "/crm/user", //users/{{uesrId}}
    crmAddUser: "/crm/user",
    crmUpdateUser: "/crm/user", //users/{{userId}}
    crmPutSearch:'/crm/user/search',
    crmPutUpdateUser:"/crm/user",
    crmPutPostUser:"/crm/user",
    crmGetMe:'/crm/user/me',
    crmGetMasterData:'/crm/master-data',
    crmPutMePipelineOrder: "/crm/user/me/pipeline-order",

    //CRM-Organization
    crmPostOrganization:'crm/organization',
    crmPutOrganization:'crm/organization',
    crmCheckOrganizationName:'crm/organization/check',

    crmGetOrganization: "/crm/organization",
    crmGetOrgDetails: "/organizations", //organizations/{{orgId}}
    crmAddOrganization: "/organizations",
    crmUpdateOrganization: "/organizations", //organizations/{{orgId}}
    crmDeleteOrganization: "/organizations", //organization/{{orgId}}
    crmMergeOrganization: "/crm/organization/merge",

    //CRM-Contact
    crmPostContacts:'/crm/contact',
    crmGetUser:'/crm/user',
    crmPutContact:'/crm/contact',

    //CRM-Stage
    crmGetStage: "/stages", //stages?pipeline_id=<integer>
    crmAddStage: "/stages",
    crmDeleteStage: "/stages", //stages/{{stage_id}}
    crmGetDealsOfStage: "/stages", //stages/{{stage_id}}
    crmUpdateStage: "/stages", //stages/{{stage_id}}

    //CRM-Roles
    crmGetRoles: "/crm/roles",

    //CRM-Roles
    getUsers: "/users",

    //ERP
    erpGetUsers: "/erp/user",
    erpGetUser:'/erp/user',
    erpPutUpdateUser:"/erp/user",
    erpPutPostUser:"/erp/user",
    erpGetRoles: "/erp/roles",
    erpGetPermissions: "/erp/permissions",

    erpPostRole:"/erp/roles",
    erpPutRole:"/erp/roles",

    erpChargeCodes: '/erp/charge-code',
    erpCurrencyProfiles: '/erp/currency-profile',
    erpCurrencyProfileItems: '/erp/currency-profile-item',
    erpEmailTemplates: '/erp/email-template',
    erpProcessCurrencyProfileItems: '/erp/currency-profile-item/process',
    erpOrganizationProfile: '/erp/organization-profile',
    erpOrganizationProfileDraft: '/erp/organization-profile/draft',
    erpVendorProfile: '/erp/vendor-profile',
    erpBankStatementItems: '/erp/bank-statement-item',
    erpProcessBankStatementItems: '/erp/bank-statement-item/process',
    erpIncomingActualReceivable: '/erp/incoming-actual-receivable',
    erpIncomingActualPayable: '/erp/incoming-actual-payable',
    erpIncomingActualPayableSummary: '/erp/incoming-actual-payable-summary',
    erpProcessChargeItems: '/erp/charge-item/process',
    erpProcessIncomingActualPayable: '/erp/incoming-actual-payable/process',
    erpBankAccounts: '/erp/bank-account',
    erpInvoices: '/erp/invoice',
    erpInvoiceItems: '/erp/invoice-item',
    erpInvoiceCreateManual: '/erp/invoice/create/manual',
    erpInvoiceDownload: '/erp/invoice/pdf',
    erpAccruals: '/erp/accrual',
    erpWarehouseCodeMappings: '/erp/warehouse-code-mapping',
    erpProcessAccruals: '/erp/accrual/process',
    erpProcessActualPayableSummaries: '/erp/incoming-actual-payable-summary/process',

    erpFileUpload: '/erp/file/upload',
    erpFileDownload: '/erp/file/download',

    erpGetMasterData:'/erp/master-data',

    erpGetMe:'/erp/user/me',

    dynamicChart: "/dynamic-chart"
}
